import styled from "styled-components";

//images
import arrowDown from "./assets/arrow-down.png";
import arrowLeft from "./assets/arrow-left.png";

export const Container = styled.div`
    flex: 1;
    height: 100%;
    background: white;
    border: thin solid #bed6e0;

    .add-friend-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.35);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }

    .add-friend-modal {
        width: 360px;
        background: linear-gradient(#f3f8ff, #e5f0ff);
        border: 1px solid #8aa7d6;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
        padding: 12px;
        color: #1e2f4d;
        font-family: Tahoma, Verdana, Arial, sans-serif;
    }

    .add-friend-title {
        font-weight: bold;
        font-size: 14px;
        padding: 6px 8px;
        background: linear-gradient(#4d6fb3, #2b4f95);
        color: white;
        border: 1px solid #2b4f95;
        margin: -12px -12px 12px;
    }

    .add-friend-subtitle {
        font-weight: bold;
        font-size: 12px;
        margin-bottom: 6px;
    }

    .add-friend-input {
        width: 100%;
        border: 1px solid #93a9c6;
        padding: 6px;
        box-shadow: inset 0 0 4px #c9d9f2;
        background: white;
        color: #1e2f4d;
        font-size: 12px;
        margin-bottom: 8px;
    }

    .add-friend-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        margin-bottom: 10px;
    }

    .add-friend-search {
        border-top: 1px solid #c2d2ea;
        padding-top: 8px;
    }

    .add-friend-search-row {
        display: flex;
        gap: 6px;
        align-items: center;
        margin-bottom: 6px;
    }

    .add-friend-results {
        max-height: 180px;
        overflow: auto;
        margin-top: 6px;
        border: 1px solid #c2d2ea;
        background: #f8fbff;
        padding: 6px;
    }

    .add-friend-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 0;
        font-size: 12px;
    }

    .add-friend-item.spaced {
        gap: 8px;
    }

    .add-friend-btn {
        border: 1px solid #7f97c2;
        background: linear-gradient(#f6fbff, #dbe9ff);
        color: #1e2f4d;
        padding: 4px 10px;
        font-size: 11px;
        cursor: pointer;
        box-shadow: inset 0 0 0 1px #ffffff;
    }

    .add-friend-btn.primary {
        background: linear-gradient(#7aa2e6, #4b78c7);
        color: white;
        border-color: #3a5fa5;
    }

    .add-friend-muted {
        color: #6d7f99;
        font-size: 11px;
    }

    .add-friend-error {
        color: #b64040;
        font-size: 11px;
    }

    #search-contacts {
        padding: 5px;
        width: 100%;
        border-bottom: 1px solid lightgray;
        display: flex;
        align-items: center;

        input {
            border: 1px solid lightgray;
            padding: 3px 3px 3px 5px;
            color: #454545;
            box-shadow: inset 0 0 3.5px lightgray;
            text-justify: center;
            width: 100%;
        }

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    #contacts-list {
        padding: 5px;
        height: 90%;
        max-height: 90%;
        overflow: auto;

        summary {
            list-style-type: none;
        }
        summary {
            font-size: 12px;
            font-weight: bold;
        }

        summary:after {
            background: url(${arrowLeft});
            background-repeat: no-repeat;

            float: left;
            height: 20px;
            width: 15px;
            content: " ";
            margin-top: 2px;
        }

        .contacts-group-list[open] summary:after {
            background: url(${arrowDown});
            background-repeat: no-repeat;
        }

        #contacts-group-list-contacts {
            margin-left: 20px;
            height: 100%;
        }
    }
`;
